<template>
  <div v-show="pageShow">
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">สินค้า</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item active">สินค้า</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- Content body. -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header d-flex">
              <div class="col-2"></div>
              <div class="col-10 text-right">
                <button class="btn btn-sm btn-primary" @click="addProduct()">
                  เพิ่มสินค้า
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table id="dataTable" class="table table-hover table-striped table-bordred">
                  <thead class="thead-light">
                    <tr>
                      <th>No.</th>
                      <th>รหัสสินค้า</th>
                      <th>ชื่อสินค้า</th>
                      <th>ลัง</th>
                      <th>ลัง/หน่วย</th>
                      <th>แพ็ก</th>
                      <th>แพ็ก/หน่วย</th>
                      <th>ประเภทสินค้า</th>
                      <th>วันที่บันทึก</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product,index) in products" :key="product.index">
                      <td>{{++index}}</td>
                      <td>{{product.product_id}}</td>
                      <td>{{product.product_name}}</td>
                      <td>{{product.crate}}</td>
                      <td>{{product.crate_unit}}</td>
                      <td>{{product.pack}}</td>
                      <td>{{product.pack_unit}}</td>
                      <td>{{product.id_type}}</td>
                      <td>{{product.created_at}}</td>
                      <td>
                        <button
                          class="btn btn-link btn-sm text-warning"
                          @click="editProduct(product)"
                        >
                          <i class="fas fa-edit"></i> Edit
                        </button>
                        <button
                          class="btn btn-link btn-sm text-danger"
                          @click="deleteProduct(product.product_id)"
                        >
                          <i class="fas fa-trash"></i> Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Modal -->
      <div class="modal" id="productModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{titleModal}}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <form @submit.prevent="actionForm ? updateProduct() : saveProduct()">
              <div class="modal-body">
                <div class="row">
                  <div class="col-6">
                    <label>ชื่อสินค้า</label>
                    <input
                      type="text"
                      v-model="form.product_name"
                      class="form-control form-control-sm"
                      placeholder="ป้อนชื่อสินค้า"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>ลัง</label>
                    <input
                      type="number"
                      v-model="form.crate"
                      class="form-control form-control-sm"
                      placeholder="ป้อนจำนวนชิ้น/ลัง"
                      required
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label>ลัง/หน่วย</label>
                    <input
                      type="text"
                      v-model="form.crate_unit"
                      class="form-control form-control-sm"
                      placeholder="ป้อน ลัง/หน่วย"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>แพ็ก</label>
                    <input
                      type="number"
                      v-model="form.pack"
                      class="form-control form-control-sm"
                      placeholder="ป้อนจำนวนชิ้น/แพ็ก"
                      required
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label>แพ็ก/หน่วย</label>
                    <input
                      type="text"
                      v-model="form.pack_unit"
                      class="form-control form-control-sm"
                      placeholder="ป้อน แพ็ก/หน่วย"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>ประเภทสินค้า</label>
                    <select v-model="form.id_type" class="form-control form-control-sm" required> 
                      <option v-for="type in typeProduct" :key="type.index" :value="type.type_name">{{type.type_name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label>สถานะสินค้า</label>
                  <select v-model="form.status" class="form-control form-control-sm">
                    <option value></option>
                    <option value="สินค้าแนะนำ">สินค้าแนะนำ</option>
                    <option value="สินค้าขายดี">สินค้าขายดี</option>
                  </select>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label>วัสดุ</label>
                    <input
                      type="text"
                      v-model="form.material"
                      class="form-control form-control-sm"
                      placeholder="ป้อนวัสดุสิค้า"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>ขนาด</label>
                    <input
                      type="text"
                      v-model="form.size"
                      class="form-control form-control-sm"
                      placeholder="ป้อนขนาดสินค้า"
                      required
                    >
                  </div>
                </div>
                <div class="form-group">
                  <label>รายละเอียด</label>
                  <textarea
                    v-model="form.detail_more"
                    class="form-control form-control-sm"
                    rows="10"
                    placeholder="รายละเอียด..."
                    required
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>รูปภาพ</label><br>
                  <img :src="getImage()" class="img-fluid" v-show="actionImg">
                  <input type="file" @change="pathImg" name="product_image" id="product_image" ref="product_image" class="form-control-file form-control-sm">
                </div>
                <div class="form-group">
                  <label>สไลด์รูปภาพ</label>
                  <input
                    type="file"
                    @change="pathFile"
                    class="form-control-file form-control-sm"
                    multiple="multiple"
                  >
                  <span class="text-danger text-10">** ขนาดรูปภาพ 500 x 500 .jpg, .png **</span>
                </div>
                <div class="row" v-if="images !=''">
                  <div class="col-md-3" v-for="image in images" :key="image.index">
                    <a href="#" @click="deleteThisImage(image.product_detail_id)" class="text-danger text-right" title="ลบรูปภาพนี้">x</a>
                    <img :src="listImage(image.path_file)" class="img-fluid">
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-success" type="submit">{{btnSubmit}}</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">ปิด</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/HeaderBack";
export default {
  components: {
    Header
  },
  data() {
    return {
      pageShow: false,
      titleModal: "",
      btnSubmit: "",
      actionForm: false,
      products: {},
      form: new Form({
        product_id:'',
        product_name: "",
        crate: "",
        crate_unit: "",
        pack: "",
        pack_unit: "",
        id_type: "",
        status: "",
        detail_more: "",
        material: "",
        size: "",
        product_image:''
      }),
      path_file: [],
      images: {},
      actionImg:false,
      product_image:'',
      typeProduct:{},
    };
  },
  beforeCreate() {
    this.axios
      .post(
        "http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin",
        {
          keyid: this.$session.get("keyid"),
          keyserial: this.$session.get("keyserial"),
          keytoken: this.$session.get("keytoken")
        }
      )
      .then(response => {
        if (response.data.checkLogin === 0) {
          this.pageShow = false;
          window.location.href = "/pageLogin";
        } else {
          this.pageShow = true;
        }
      });
  },
  methods: {
    listTypeProduct(){
      this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/dataTypeProduct')
      .then((res)=>{
        this.typeProduct = res.data
      })
    },
    pathImg(e){
      this.actionImg = true;
      let file = e.target.files[0];
      let reader = new FileReader();
      if (file['type'] === 'image/jpeg' || file['type'] === 'image/png') {
        this.product_image = this.$refs.product_image.files[0];
        reader.onload = file => {
          this.form.product_image = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        swal.fire({
          type: "error",
          title: "Opps...",
          text: "You are uploading a large file"
        });
      }
    },
    getImage() {
      let photo = (this.form.product_image.length > 200) ? this.form.product_image : 'http://pgm01.toonjob.com/2019/BannKlong/image/products/'+this.form.product_image;
      return photo;
    },
    addProduct() {
      this.form.reset()
      this.images = ''
      $("#productModal").modal("show");
      this.titleModal = "เพิ่มสินค้า";
      this.btnSubmit = "บันทึกสินค้า";
      this.actionForm = false;
      this.actionImg = false
    },
    editProduct(product) {
      this.images = ''
      $("#productModal").modal("show");
      this.form.fill(product)
      this.titleModal = "แก้ไขสินค้า";
      this.btnSubmit = "บันทึกและแก้ไข";
      this.actionForm = true;
      this.actionImg = true
      this.dataImage(product.product_id)
    },
    saveProduct() {
      let dataForms = new FormData();
      for (let i = 0; i < this.path_file.length; i++) {
        dataForms.append("path_file[]", this.path_file[i]);
      }
      dataForms.append("product_name", this.form.product_name);
      dataForms.append("crate", this.form.crate);
      dataForms.append("crate_unit", this.form.crate_unit);
      dataForms.append("pack", this.form.pack);
      dataForms.append("pack_unit", this.form.pack_unit);
      dataForms.append("detail_more", this.form.detail_more);
      dataForms.append("id_type", this.form.id_type);
      dataForms.append("status", this.form.status);
      dataForms.append("material", this.form.material);
      dataForms.append("size", this.form.size);
      dataForms.append("product_image", this.product_image);
      const config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios
        .post(
          "http://pgm01.toonjob.com/2019/BannKlong/project/saveProduct",
          dataForms,
          config
        )
        .then(response => {
          this.form.reset()
          this.path_file = ''
          Fire.$emit("AfterProduct");
          $("#productModal").modal("hide");
          toast.fire({
            type: "success",
            title: response.data.message
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateProduct() {
      let dataForms = new FormData();
      for (let i = 0; i < this.path_file.length; i++) {
        dataForms.append("path_file[]", this.path_file[i]);
      }
      dataForms.append("product_id", this.form.product_id);
      dataForms.append("product_name", this.form.product_name);
      dataForms.append("crate", this.form.crate);
      dataForms.append("crate_unit", this.form.crate_unit);
      dataForms.append("pack", this.form.pack);
      dataForms.append("pack_unit", this.form.pack_unit);
      dataForms.append("detail_more", this.form.detail_more);
      dataForms.append("id_type", this.form.id_type);
      dataForms.append("status", this.form.status);
      dataForms.append("material", this.form.material);
      dataForms.append("size", this.form.size);
      dataForms.append("product_image", this.product_image);
      const config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/updateProduct', dataForms, config)
      .then((response) => {
        $('#productModal').modal('hide')
        toast.fire({
          type:'success',
          title:response.data.message
        })
        Fire.$emit('AfterProduct')
      })
    },
    deleteProduct(id) {
      swal
        .fire({
          title: "Are you sure?",
          text: "You won't delete this user!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            this.axios
              .post(
                "http://pgm01.toonjob.com/2019/BannKlong/project/deleteProduct",
                {
                  id: id
                }
              )
              .then(response => {
                swal.fire("Deleted!", response.data.message, "success");
                Fire.$emit("AfterProduct");
              });
          }
        });
    },
    deleteThisImage(image){
      this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/deleteThisImageProduct', {id: image})
      .then((response) => {
        this.dataImage(this.form.product_id)
        toast.fire({
          type:'success',
          title: response.data.message
        })
      })
    },
    dataProduct() {
      this.axios
        .get("http://pgm01.toonjob.com/2019/BannKlong/project/dataProduct")
        .then(response => {
          this.products = response.data;
          $(document).ready(function() {
            $("#dataTable").DataTable();
          });
        });
    },
    dataImage(id){
      this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/listImageProduct', {product_id: id})
      .then((response) => {
        this.images = response.data
      })
    },
    pathFile(e) {
      let file = e.target.files;
      for (let i = 0; i < file.length; i++) {
        this.path_file.push(file[i]);
      }
    },
    listImage(e) {
      let photo = "http://pgm01.toonjob.com/2019/BannKlong/image/products/"+ e;
      return photo;
    }
  },
  created() {
    this.$Progress.start();
    this.dataProduct();
    this.listTypeProduct()
    Fire.$on("AfterProduct", () => {
      this.dataProduct();
    });
    this.$Progress.finish();
  }
};
</script>


// WEBPACK FOOTER //
// src/backEnd/ProductPage.vue